const idMappingEliminatorias = {
  "5m9cv89dxqg33qbdgfynvc6c4": "73",
  "tcobopf76p8yaw9kit3fs8pg" : "74",
  "7hnbukswespa64jtdc81jgetw": "75",
  "3hsg9oklerq6uua8pos3dmdck": "76",
  "37odjdevbj57umggq3rh1az9w": "77",
  "56nac7cdfhydresgbalcg33tg": "78",
  "6x9sfww0qsk9jtn9fm6n2qk2c": "79",
  "9x9n058kxdo1mmyyd0bngy49g": "80",
  "ef8yvmn1ivhbrnjyj133kf7ys": "81",
  "1tges3bmhq44q1m8ojj9fhr10": "82",
  "a9a29jmg821rce6jl07v6rod0": "84",
  "c26uegvn7o8d3uyb04tuuxjbo": "83",
  
  "1pah6dqrmiqvtouxgbzlzoefo": "85",
  "c328g6toeflzg65gf28592olw": "88",
  "3e05jx7evbp03r1yvu3ryg0t0": "87",
  "etsoc4p3zsifly6xks7ossl5g": "86",
  "71syco9icpb3gpojexfq9sh04": "89",
  "1tfdd32vy6ouod43ek7l7kc9g": "90",
  "9fqb3vpytcmgk9pozahr7iz9w": "91",
  "b083yrj18tbck1z0og2evbhuc": "92",
  "5fim3od605k9wne6uuiw641ec": "93",
  "7djxwsgj6k02ts4b8lj2akqok": "94",
  "ceq6z0bte8pgdbc2uwxni0x78": "95",
  "em70mwgw22fdt9i4womogw93o": "96",
  "1ot14rn6x26nlaxaxt27wkrv8": "97",
  "3a1xofm1wnspw1952k7e4du6s": "98",
  "4mcheqqscjz2gduxagmcgeyhg": "99",
  "68n1p6yn5507yxvrrgfzod3bo": "100",
  "61zv9h8fu4v0812uihvl7m3h0": "101",
  "9jubv7maziug1x60neaq76g44": "102",
  "1wrjcpwj8cv0mb6d4yp67dams": "103",
  "57dotnff3xaafnxfltzt4czdg": "104"
};

/**
 * Convierte un ID de partido de eliminatoria a su número equivalente (73, 74, etc.)
 * @param {string} eliminatoriaId - El ID largo del partido
 * @returns {string} - El número del partido o el ID original si no está en el mapeo
 */
export const getMatchNumberFromId = (eliminatoriaId) => {
  return idMappingEliminatorias[eliminatoriaId] || eliminatoriaId;
};

/**
 * Convierte un número de partido a su ID largo
 * @param {string} matchNumber - El número del partido (73, 74, etc.)
 * @returns {string} - El ID largo del partido o el número original si no está en el mapeo
 */
export const getIdFromMatchNumber = (matchNumber) => {
  for (const [id, num] of Object.entries(idMappingEliminatorias)) {
    if (num === matchNumber.toString()) {
      return id;
    }
  }
  return matchNumber;
};

/**
 * Reemplaza todos los IDs de partidos de eliminatorias por sus números equivalentes
 * Reemplaza las claves (keys) en el objeto OFFICIAL_RESULTS
 * @param {object} data - El objeto a procesar (tipicamente OFFICIAL_RESULTS)
 * @returns {object} - El objeto con IDs de eliminatorias reemplazados por números
 */
export const replaceEliminatoriaIds = (data) => {
  if (typeof data !== 'object' || data === null) {
    return data;
  }

  if (Array.isArray(data)) {
    return data.map(item => replaceEliminatoriaIds(item));
  }

  // Para objetos, procesar las claves y valores
  const result = {};
  for (const [key, value] of Object.entries(data)) {
    // Reemplazar la clave si es un ID de eliminatoria
    const newKey = idMappingEliminatorias[key] || key;
    
    if (typeof value === 'object' && value !== null) {
      // Si el valor es un objeto/array, procesarlo recursivamente
      result[newKey] = replaceEliminatoriaIds(value);
    } else {
      // Mantener el valor tal cual
      result[newKey] = value;
    }
  }

  return result;
};

export default {
  idMappingEliminatorias,
  getMatchNumberFromId,
  getIdFromMatchNumber,
  replaceEliminatoriaIds
};